import React, {FC, useEffect} from 'react';
import Header from "../components/header/Header";
import {Outlet, useSearchParams} from "react-router-dom";
import Alert from "../components/Alerter/Alert";
import useUserStore from "../store/userStore";
import useAlertStore from "../store/alertStore";
import {GetAllSearchParams} from "../utilities/GetAllSearchParams";

const Root = () => {

    const {setToken,setFIO,setLogin} = useUserStore(state => state);
    const {addAlert} = useAlertStore();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const [searchParams,setSearchParams] = useSearchParams();
    /*
    useEffect(()=>{
        let token = searchParams.get('token');
        let fio = searchParams.get('fio');
        let login = searchParams.get('login');
        if(token)
            setToken(token);
        if(fio)
            setFIO(fio);
        if(login)
            setLogin(login);
        if(token || fio || login) {
            const params = GetAllSearchParams(searchParams);
            // @ts-ignore
            delete params['token'];
            // @ts-ignore
            delete params['fio'];
            // @ts-ignore
            delete params['login'];
            setSearchParams({...params});
            //window.location.search = ``;
            addAlert({uid: String(Date.now()), type: "success", message: "Вы успешно авторизовались!"}, 10000);
        }

    },[])
     */

    return (
        <div>
            <Header/>
            <Outlet />
            <Alert/>
        </div>
    );
};

export default Root;